import { useSubscription } from "@/context/SubscriptionContext";
import { Lock, AlertTriangle } from "lucide-react";
import { Link } from "react-router-dom";

/**
 * Persistent banner shown app-wide when subscription is in grace or expired state.
 * Renders nothing when subscription is active.
 */
export const SubscriptionBanner = () => {
  const { status, isLocked, nextDueDate, monthlyAmount, currency, ready } = useSubscription();
  if (!ready || (status === "active" && !isLocked)) return null;

  const due = nextDueDate ? new Date(nextDueDate).toLocaleDateString("en-IN") : "—";
  const amt = monthlyAmount ? `${currency || "INR"} ${monthlyAmount}` : "";

  if (isLocked || status === "expired") {
    return (
      <div className="bg-red-600 text-white text-center py-2 px-4 text-xs sm:text-sm font-semibold sticky top-0 z-50 shadow-md" data-testid="subscription-locked-banner">
        <Lock className="h-4 w-4 inline mr-2" />
        <b>Subscription overdue.</b> All edits are locked. Please contact your vendor to unlock.{" "}
        {amt && <span className="opacity-80">Due: {amt} (since {due})</span>}{" "}
        <Link to="/admin/subscription" className="underline ml-2 hover:opacity-90">Vendor view →</Link>
      </div>
    );
  }
  if (status === "grace") {
    return (
      <div className="bg-amber-500/95 text-black text-center py-2 px-4 text-xs sm:text-sm font-semibold sticky top-0 z-50 shadow-md" data-testid="subscription-grace-banner">
        <AlertTriangle className="h-4 w-4 inline mr-2" />
        <b>Payment due.</b> You have 7 days grace period (until app locks). Please clear your dues to continue using the app.{" "}
        {amt && <span className="opacity-80">Amount: {amt}</span>}
      </div>
    );
  }
  return null;
};

export default SubscriptionBanner;
